// Helper to generate bounding boxes from Census Bureau boundary data
import { stateBoundaries } from '../data/censusBoundaries';

// Generate bounding boxes from the real boundary coordinates
function generateBoundingBoxes() {
  const bounds: Record<string, { minLat: number; maxLat: number; minLng: number; maxLng: number }> = {};
  
  Object.entries(stateBoundaries).forEach(([stateName, boundary]) => {
    let minLat = Infinity, maxLat = -Infinity;
    let minLng = Infinity, maxLng = -Infinity;
    
    boundary.coordinates.forEach(([lng, lat]) => {
      minLat = Math.min(minLat, lat);
      maxLat = Math.max(maxLat, lat);
      minLng = Math.min(minLng, lng);
      maxLng = Math.max(maxLng, lng);
    });
    
    bounds[stateName] = { minLat, maxLat, minLng, maxLng };
  });
  
  return bounds;
}

export const censusBoundingBoxes = generateBoundingBoxes();

// Point-in-polygon test using ray casting algorithm
export function isPointInPolygon(point: [number, number], polygon: [number, number][]): boolean {
  const [lng, lat] = point;
  let inside = false;
  
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const [xi, yi] = polygon[i];
    const [xj, yj] = polygon[j];
    
    if (((yi > lat) !== (yj > lat)) && (lng < (xj - xi) * (lat - yi) / (yj - yi) + xi)) {
      inside = !inside;
    }
  }
  
  return inside;
}

// More accurate state detection using real polygons
export function detectStateFromCoordinates(lat: number, lng: number): string | null {
  const point: [number, number] = [lng, lat];
  
  // First check bounding boxes for efficiency
  for (const [stateName, bounds] of Object.entries(censusBoundingBoxes)) {
    if (lat >= bounds.minLat && lat <= bounds.maxLat &&
        lng >= bounds.minLng && lng <= bounds.maxLng) {
      
      // If in bounding box, do precise polygon test
      const boundary = stateBoundaries[stateName];
      if (boundary && isPointInPolygon(point, boundary.coordinates)) {
        return stateName;
      }
    }
  }
  
  return null;
}